import { $translate } from '@/utils/i18n';
export const config = {
    configuration: true,
    searchList: {
        searchTxt: [
            {
                name: $translate('lang.E3202208010001', { defaultText: '来源系统名称' }),
                value: 'sourceSys',
                type: 'select',
                options: [],
                unfold: true,
                span: 6
            },
            {
                value: 'createTime',
                type: 'datePicker',
                unfold: true,
                timeNum: 6,
                span: 10
            }
        ],
        isInquire: true,
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: '来源系统名称',
                align: 'center',
                prop: 'sourceSys',
                width: 120
            },
            {
                label: '统计日期',
                align: 'center',
                prop: 'createTime',
                width: 120
            },
            {
                label: '统计量',
                align: 'center',
                prop: 'count',
                width: 120
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
